<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">Edit {{ module }}</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboards' }">Dashboards</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link :to="{ name: table_module }">{{ module }}</router-link>
              </li>
              <li class="breadcrumb-item active">Edit</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <loading :active="isLoading" :is-full-page="false"></loading>
        <form>
          <div class="row">
            <div class="col-12 form-group">
              <label for="">Tanggal Penggajian</label>
              <datepicker input-class="form-control form-control-sm mb-2" format="dd MMMM yyyy" required
                v-model="post.date" />
            </div>
          </div>
          <div class="row">
            <div class="col-6 form-group">
              <label for="">Periode</label>
              <input type="text" class="form-control form-control-sm" v-model="post.periode" readonly />
            </div>
            <div class="col-6 form-group">
              <label for="">Nama Karyawan</label>
              <input type="hidden" class="form-control form-control-sm" v-model="post.emp_id" />
              <input type="hidden" class="form-control form-control-sm" v-model="post.emp_uuid" />
              <input type="text" class="form-control form-control-sm" v-model="post.emp_name" readonly />
            </div>
          </div>
          <div class="row">
            <div class="col-12 form-group">
              <label for="">Gaji Pokok</label>
              <money class="form-control form-control-sm" v-model="post.gaji" v-bind="money" required
                @input="totalGaji()"></money>
            </div>
          </div>
          <div class="card">
            <div class="card-header">Insentif</div>
            <div class="card-body">
              <div class="row">
                <div class="col-3 form-group">
                  <label for="">Total Pencapaian</label>
                  <money class="form-control form-control-sm" v-model="post.insentif.pencapaian" v-bind="money" required
                    readonly>
                  </money>
                </div>
                <div class="col-3 form-group">
                  <label for="">Target</label>
                  <money class="form-control form-control-sm" v-model="post.insentif.target" v-bind="money" required
                    readonly>
                  </money>
                </div>
                <div class="col-auto">
                  <label for="">Insentif Percent</label>
                  <div class="input-group input-group-sm ">
                    <input type="text" class="form-control" placeholder="Komisi" v-model="post.insentif.komisi"
                      @input="setTotalInsentif()" />
                    <div class="input-group-append">
                      <span class="input-group-text">%</span>
                    </div>
                  </div>
                </div>
                <div class="col-3 form-group">
                  <label for="">Total Insentif</label>
                  <money class="form-control form-control-sm" v-model="post.insentif.total" v-bind="money" required
                    readonly>
                  </money>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 form-group">
              <label for="">Lemburan</label>
              <div class="d-flex content-justify-between align-center">
                <money class="form-control form-control-sm col-5 mr-2" v-model="post.lembur.amount" v-bind="money"
                  @input="setTotalLembur()" required></money>
                <div class="input-group input-group-sm ">
                  <input type="text" class="form-control" placeholder="Durasi" v-model="post.lembur.durasi"
                    @input="setTotalLembur()" required />
                  <div class="input-group-append">
                    <span class="input-group-text">Jam</span>
                  </div>
                </div>
                <money class="form-control form-control-sm col-5 ml-2" v-model="post.lembur.total" v-bind="money" required
                  readonly>
                </money>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6 form-group">
              <label for="">Tunjangan</label>
              <div class="item-tunjangan mb-2" v-for="(input, key) in post.tunjangan" :key="key">
                <div class="d-flex content-justify-between align-center">
                  <input type="text" class="form-control form-control-sm" v-model="input.name" />
                  <money class="form-control form-control-sm ml-2" v-model="input.value" v-bind="money" required
                    @input="totalTunjangan(), totalGaji()" />
                  <button class="btn btn-danger btn-sm ml-1" type="button" @click="hapusTunjangan(key)"><i
                      class="fa fa-trash"></i></button>
                </div>
              </div>
              <div class="mb-2">
                <div class="d-flex content-justify-between align-items-center">
                  <div class="col-6">
                    <p><b>Total Tunjangan</b></p>
                  </div>
                  <div>
                    <input type="hidden" v-model="post.total_tunjangan">
                    <p><b>Rp. {{ numberWithCommas(post.total_tunjangan) }}</b></p>
                  </div>
                </div>
              </div>
              <button class="btn btn-outline-primary btn-sm mt-2" type="button" @click="tambahTunjangan()"><i
                  class="fa fa-pluse"></i>
                Tambah Tunjangan</button>
            </div>
            <div class="col-6 form-group">
              <label for="">Potongan</label>
              <div class="item-potongan mb-2" v-for="(input, key) in post.potongan" :key="key">
                <div class="d-flex content-justify-between align-items-center">
                  <input type="text" class="form-control form-control-sm" v-model="input.name" />
                  <money class="form-control form-control-sm ml-2" v-model="input.value" v-bind="money" required
                    @input="totalPotongan()" />
                  <button class="btn btn-danger btn-sm ml-1" type="button" @click="hapusPotongan(key)"><i
                      class="fa fa-trash"></i></button>
                </div>
              </div>
              <div class="mb-2">
                <div class="d-flex content-justify-between align-items-center">
                  <div class="col-6">
                    <p><b>Total Potongan</b></p>
                  </div>
                  <div>
                    <input type="hidden" v-model="post.total_potongan">
                    <p><b>Rp. {{ numberWithCommas(post.total_potongan) }}</b></p>
                  </div>
                </div>
              </div>
              <button class="btn btn-outline-primary btn-sm mt-2" type="button" @click="tambahPotongan()"><i
                  class="fa fa-pluse"></i>
                Tambah Potongan</button>
            </div>
          </div>
          <div class="row">
            <div class="col-12 form-group">
              <label for="">Catatan</label>
              <textarea name="" id="" cols="5" rows="5" class="form-control" v-model="post.note"></textarea>
            </div>
          </div>
          <div class="row">
            <div class="col-12 form-group">
              <label for="">Total Pengajian</label>
              <money class="form-control form-control-sm" v-model="post.total_gaji" v-bind="money" required readonly />
            </div>
          </div>
          <div class="row">
            <div class="col-12 form-group">
              <label for="">Status Penggajian</label>
              <v-select :options="options" v-model="post.status" />
            </div>
          </div>
          <div class="btn-group">
            <button type="button" class="btn btn-primary save-form" @click="SaveForm()">Simpan</button>
            <button type="button" class="btn btn-danger reset-form" @click="resetData()">Reset</button>
            <router-link class="btn btn-warning" :to="{ name: table_module }">Kembali</router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Money } from "v-money";
import Datepicker from "vuejs-datepicker";
export default {
  data() {
    return {
      module: "Payroll",
      table_module: "payroll",
      alias_table: "payroll",
      fields: {},
      uuid: this.$route.params.uuid,
      year: this.$route.params.year,
      post: {},
      money: {
        thousands: '.',
        prefix: 'Rp ',
        precision: 0,
      },
      options: [
        'Sudah',
        'Belum'
      ],
      isLoading: false
    };
  },
  components: {
    Money,
    Datepicker,
  },
  mounted() {
    this.getData()
  },
  methods: {
    setTotalInsentif() {
      var bonusTarget = this.post.insentif.pencapaian - this.post.insentif.target;
      var komisi = this.post.insentif.komisi;
      this.post.insentif.total = bonusTarget * komisi / 100;
      this.post.total_insentif = this.post.insentif.total;

      this.totalGaji()
    },
    setTotalLembur() {
      var amount = this.post.lembur.amount;
      var durasi = this.post.lembur.durasi;
      this.post.lembur.total = amount * durasi;
      this.post.total_lembur = amount * durasi;

      this.totalGaji()
    },
    tambahTunjangan() {
      this.post.tunjangan.push({
        name: "",
        value: 0
      });
    },
    hapusTunjangan(key) {
      this.post.tunjangan.splice(key, 1);
      this.totalGaji()
    },
    tambahPotongan() {
      this.post.potongan.push({
        name: "",
        value: 0
      });
    },
    hapusPotongan(key) {
      this.post.potongan.splice(key, 1);
      this.totalGaji()
    },
    totalTunjangan() {
      var total = this.post.tunjangan.reduce((acc, item) => acc + item.value, 0);
      this.post.total_tunjangan = total;
      this.totalGaji()
    },
    totalPotongan() {
      var total = this.post.potongan.reduce((acc, item) => acc + item.value, 0);
      this.post.total_potongan = total;
      this.totalGaji()
    },
    totalGaji() {
      this.post.total_gaji = this.post.gaji + this.post.total_insentif + this.post.total_tunjangan + this.post.total_lembur - this.post.total_potongan
    },
    numberWithCommas(arm) {
      if (arm != "" && arm != null) {
        return arm.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
      return 0;
    },
    SaveForm() {
      this.isLoading = true;
      this.axios
        .post("/payroll/update", this.post)
        .then((response) => {
          console.log(response)
          if (response.data.status == 200) {
            this.isLoading = false;
          }
        });
    },
    getData() {
      this.axios
        .get("/" + this.table_module + "/edit/" + this.year + "/" + this.uuid)
        .then(response => {
          this.post = response.data.data.payroll;
        })
        .catch(error => {
          if (error.response) {
            this.$router.push({ name: this.table_module });
          } else if (error.request) {
            console.log("Error", error.message);
          } else {
            console.log("Error", error.message);
          }
        });
    },
    resetData() {
      var Swal = this.$swal;
      Swal.fire({
        title: "Yakin ingin mereset pengajian ini?",
        // text: "You will not be able to recover this imaginary file!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it",
      }).then((result) => {
        if (result.value) {
          this.axios
            .get("/" + this.table_module + "/reset/" + this.year + "/" + this.uuid)
            .then(response => {
              this.post = response.data.content.payroll;
            })
            .catch(error => {
              if (error.response) {
                this.$router.push({ name: this.table_module });
              } else if (error.request) {
                console.log("Error", error.message);
              } else {
                console.log("Error", error.message);
              }
            });
        }
      });
    }
  },
};
</script>